var a = { icon: { tag: "svg", attrs: { viewBox: "0 0 16 16", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M8 3c.15 0 .3.08.37.2l4.55 6.91c.2.3-.01.7-.37.7H10v4.74c0 .25-.3.45-.67.45H6.67c-.37 0-.67-.2-.67-.45v-4.73H3.45a.45.45 0 01-.37-.7L7.63 3.2c.08-.12.22-.2.37-.2zm4-3a1 1 0 010 2H4a1 1 0 010-2h8z", "fill-rule": "nonzero" } }] }, name: "to-top", theme: "filled" };
export {
  a as default
};
